import { IItem, ISubMenuItems } from "../types/common.interface";

const TOP_MENU_ROLE_ADMIN: ISubMenuItems[] = [
  { value: 'dashboard'     , pathname: '/panel/administrator/dashboard'       },
  { value: 'governmentShip', pathname: '/panel/administrator/government-ship' },
  { value: 'superAgent'    , pathname: '/panel/administrator/super-agent'     },
  { value: 'municipality'  , pathname: '/panel/administrator/municipality'    },
  { value: 'company'       , pathname: '/panel/administrator/company'         },
  { value: 'school'        , pathname: '/panel/administrator/school'          },
  { value: 'driver'        , pathname: '/panel/administrator/driver'          },
  { value: 'service'       , pathname: '/panel/administrator/service'         },
  { value: 'parent'        , pathname: '/panel/administrator/parents'         },
  { value: 'absent'        , pathname: '/panel/administrator/absent'          },
  { value: 'history'       , pathname: '/panel/administrator/history'         },
  { value: 'financial'     , pathname: '/panel/administrator/financial'       },
  { value: 'support'       , pathname: '/panel/administrator/ticket'          },
  { value: 'operator'      , pathname: '/panel/administrator/user'            },
  { value: 'location'      , pathname: '/panel/administrator/location'        },
  { value: 'academic_year' , pathname: '/panel/administrator/academic-year'   },
];
const TOP_MENU_ROLE_ADMIN_WITHOUT_Financial: ISubMenuItems[] = [
  { value: "dashboard", pathname: "/panel/administrator/dashboard" },
  { value: "governmentShip", pathname: "/panel/administrator/government-ship" },
  { value: "superAgent", pathname: "/panel/administrator/super-agent" },
  { value: "municipality", pathname: "/panel/administrator/municipality" },
  { value: "company", pathname: "/panel/administrator/company" },
  { value: "school", pathname: "/panel/administrator/school" },
  { value: "driver", pathname: "/panel/administrator/driver" },
  { value: "service", pathname: "/panel/administrator/service" },
  { value: "parent", pathname: "/panel/administrator/parents" },
  { value: "absent", pathname: "/panel/administrator/absent" },
  { value: "history", pathname: "/panel/administrator/history" },
  { value: "operator", pathname: "/panel/administrator/user" },

  // { value: "financial", pathname: "/panel/administrator/financial" },
  // { value: "other", pathname: "/panel/administrator/other" },
];
const TOP_MENU_ROLE_GOVERNMENTSHIP: ISubMenuItems[] = [
  { value: "dashboard", pathname: "/panel/government-ship/dashboard" },
  // { value: "آموزش و پرورش", pathname: "/panel/government-ship/super-agent" },
  { value: "municipality", pathname: "/panel/government-ship/municipality" },
  { value: "company", pathname: "/panel/government-ship/company" },
  // { value: "school", pathname: "/panel/government-ship/school" },
  { value: "driver", pathname: "/panel/government-ship/driver" },
  // { value: "service", pathname: "/panel/government-ship/service" },
  // { value: "parent", pathname: "/panel/government-ship/parents" },
  // { value: "absent ها", pathname: "/panel/government-ship/absent" },
  // { value: "history", pathname: "/panel/government-ship/history" },
  // { value: "financial", pathname: "/panel/government-ship/financial" },
  // { value: "other", pathname: "/panel/government-ship/other" },
];
const TOP_MENU_ROLE_PROVINCE_EDUCATION: ISubMenuItems[] = [
  { value: "dashboard", pathname: "/panel/province-education/dashboard" },
  { value: "superAgent", pathname: "/panel/province-education/super-agent" },
  // { value: "municipality", pathname: "/panel/province-education/municipality" },
  // { value: "companyها", pathname: "/panel/province-education/company" },
  { value: "school", pathname: "/panel/province-education/school" },
  // { value: "driver", pathname: "/panel/province-education/driver" },
  { value: "service", pathname: "/panel/province-education/service" },
  { value: "parent", pathname: "/panel/province-education/parents" },
  // { value: "absent ها", pathname: "/panel/province-education/absent" },
  // { value: "history", pathname: "/panel/province-education/history" },
  // { value: "financial", pathname: "/panel/province-education/financial" },
  // { value: "other", pathname: "/panel/province-education/other" },
];

const TOP_MENU_ROLE_SUPER_AGENT: ISubMenuItems[] = [
  { value: "dashboard", pathname: "/panel/super-agent/dashboard" },
  { value: "company", pathname: "/panel/super-agent/company" },
  { value: "school", pathname: "/panel/super-agent/school" },
  { value: "driver", pathname: "/panel/super-agent/driver" },
  { value: "service", pathname: "/panel/super-agent/service" },
  { value: "parent", pathname: "/panel/super-agent/parent" },
  { value: "absent", pathname: "/panel/super-agent/absent" },
  { value: "history", pathname: "/panel/super-agent/history" },
  { value: "financial", pathname: "/panel/super-agent/financial" },
];

const TOP_MENU_ROLE_COMPANY: ISubMenuItems[] = [
  { value: "dashboard", pathname: "/panel/company/dashboard" },
  { value: "driver", pathname: "/panel/company/driver" },
  { value: "school", pathname: "/panel/company/school" },
  { value: "service", pathname: "/panel/company/service" },
  { value: "parent", pathname: "/panel/company/parents" },
  { value: "absent", pathname: "/panel/company/absent" },
  { value: "history", pathname: "/panel/company/history" },
  { value: "financial", pathname: "/panel/company/financial" },
  { value: "location", pathname: "/panel/company/location" },
  { value: "support", pathname: "/panel/company/ticket" },
  { value: "other", pathname: "/panel/company/other" },
];
const TOP_MENU_ROLE_Municipality: ISubMenuItems[] = [
  { value: "dashboard", pathname: "/panel/municipality/dashboard" },
  { value: "company", pathname: "/panel/municipality/company" },
  { value: "driver", pathname: "/panel/municipality/driver" },
  { value: "school", pathname: "/panel/municipality/school" },
  { value: "service", pathname: "/panel/municipality/service" },
  { value: "parent", pathname: "/panel/municipality/parents" },
  // { value: "absent ها", pathname: "/panel/municipality/absent" },
  // { value: "history", pathname: "/panel/municipality/history" },
  // { value: "financial", pathname: "/panel/municipality/financial" },
];

const LOGIN_ROLE_ITEM: IItem[] = [
  { name: "governmentShip", value: "GOVERNMENTSHIP" },
  { name: "provinceEducation", value: "PROVINCE_EDUCATION" },
  { name: "superAgent", value: "SUPER_AGENT_SCHOOL" },
  { name: "municipality", value: "MUNICIPALITY" },
  { name: "company", value: "COMPANY" },
];

const LOGIN_ROLE_DRIVER: IItem[] = [
  { name: "driver", value: "DRIVER" },
];

const REGISTER_ROLE_ITEM: IItem[] = [{ name: "company", value: "COMPANY" }];

const APPROVE_ROLE_ADMIN: IItem[] = [
  { name: "superAgent", value: "SUPER_AGENT_SCHOOL" },
  { name: "company", value: "COMPANY" },
  { name: "parent", value: "PASSENGER" },
];
const APPROVE_ROLE_COMPANY: IItem[] = [
  { name: "company", value: "COMPANY" },
  { name: "parent", value: "PASSENGER" },
];

const TOP_MENU_ROLE_DRIVER: ISubMenuItems[] = [
  // { value: "dashboard", pathname: "/driver/dashboard" },
  // { value: "service", pathname: "/driver/service" },
  // { value: "financial", pathname: "/driver/financial" },
  { value: "setting", pathname: "/driver/setting" },
];

const topMenuItems = {
  TOP_MENU_ROLE_DRIVER,
  TOP_MENU_ROLE_Municipality,
  TOP_MENU_ROLE_SUPER_AGENT,
  TOP_MENU_ROLE_COMPANY,
  TOP_MENU_ROLE_ADMIN,
  APPROVE_ROLE_ADMIN,
  LOGIN_ROLE_DRIVER,
  REGISTER_ROLE_ITEM,
  LOGIN_ROLE_ITEM,
  TOP_MENU_ROLE_GOVERNMENTSHIP,
  TOP_MENU_ROLE_PROVINCE_EDUCATION,
  TOP_MENU_ROLE_ADMIN_WITHOUT_Financial,
  APPROVE_ROLE_COMPANY,
};

export default topMenuItems;
